// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"910d14dc","507":"732442b3","520":"a2564102","714":"3bab94de","737":"0c22fc30","963":"f7a14bca"}[chunkId] + ".chunk.js";
};